const baseData = {
  state: {
    pageData: {},
    isPhone: 0
  },
  mutations: {
    setPageData: (state, data) => {
      state.pageData = data
    },
    setDeviceData: (state, data) => {
      state.isPhone = data
    }
  },
  actions: {
    ADD_ERROR_LOG({ commit }, log) {
      commit('ADD_ERROR_LOG', log)
    }
  }
}

export default baseData



// WEBPACK FOOTER //
// ./src/store/modules/baseData.js